'use client';

import { ChevronDownIcon } from '@/components/ui/icons';
import { useState } from 'react';
import { BenefitIcon } from './BenefitIcon';
import type { Benefit } from './MembershipBenefits.types';

export function BenefitCard({ icon, title, detail }: Benefit) {
  const [open, setOpen] = useState(false);

  return (
    <div className='flex gap-5'>
      <BenefitIcon name={icon} className='h-20 w-20 shrink-0' />
      <div className='pt-1'>
        <h3 className='text-sh-navy font-sans text-[20px] leading-[130%] font-medium'>
          {title}
        </h3>
        <button
          type='button'
          onClick={() => setOpen(o => !o)}
          aria-expanded={open}
          className='text-sh-navy mt-2 flex cursor-pointer items-center gap-2 font-sans text-[16px]'
        >
          Read more
          <ChevronDownIcon
            className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`}
          />
        </button>
        <div
          className={`grid transition-all duration-300 ease-out ${
            open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
          }`}
        >
          <div className='overflow-hidden'>
            <p className='text-sh-navy mt-2 max-w-[320px] font-sans text-[15px] leading-[150%]'>
              {detail}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
